import React from 'react';
import styled from 'styled-components';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';

type HeaderType =
  'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'div' | 'label' | 'span';

export interface CondensedLabelProps {
  as?: HeaderType;
  children?: React.ReactNode;
  className?: string;
  name?: string | null;
  maxLines?: number | null;
  /**
   * Breaks a word anywhere rather than only where it could. Without it a run with no space in it -
   * a url, a hash, a pasted token - is one unbreakable word: it cannot wrap, so it sets the width
   * of whatever holds it and spills out of it rather than filling the lines `maxLines` allows.
   *
   * Only read alongside `maxLines`, which is what draws the lines to be kept to.
   */
  maxLinesStrict?: boolean;
}

interface H6Props {
  as: HeaderType;
  children: React.ReactNode;
  dataTest: string;
}

const Label = ({ as, children, dataTest }: H6Props) =>
  React.createElement(as, { dataTest }, children);

const StyledLabel = styled(Label)``;

export const CondensedLabel = ({
  as = 'label',
  children = null,
  className = '',
  name = null,
  maxLines = null,
  maxLinesStrict = false,
}: CondensedLabelProps) => (
  <StyledLabel
    as={as}
    className={AttrsHelper.formatClassname(
      'condensed-label',
      maxLines && `max-lines-${maxLinesStrict ? 'strict-' : ''}${maxLines}`,
      className
    )}
    data-test={name}
  >
    {children}
  </StyledLabel>
);
